export enum EditFieldControlTypeEnum {
    Textbox,
    Date,
    Ccce,
    Dropdown,
    Numeric
}
